import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const productOptions = {
    namespaced: true,
    //响应动作
    actions:{

    },
    //操作数据
    mutations:{

    },
    //存储数据
    state:{

    },
    //获取数据
    getters:{

    }
}

export default new Vuex.Store({
    modules:{
        productOptions
    }
})




// WEBPACK FOOTER //
// ./src/store/index.js